<template>
<div id="detectionwork">
    <div class="container">
        <div class="row" >
            <div class="col-sm-12">
                <form action="" method="post">
                    <h2>職場</h2>
                    <div class="form-block">
                        <div v-show="step === 1" id="form_part1">
                            <div class="container">
                                <p>身為職場新鮮人，雖然是部門內的基層人員，但你努力學習，一心盼望大展身手。漸漸地，你贏得主管看重，被交付大型案子也不負所託，主管讚賞的說：「好好跟著我，我會給你更多的機會，升官少不了你。」主管的肯定，讓你充滿自信，雖然壓力增加、工作時間延長，但你覺得這是必經過程，再辛苦也值得。<br>隨著時間流逝，升官加薪始終毫無下文，有的只是做不完的工作。而每當你提及這個話題，主管總是安撫你稍安勿躁，並順勢交辦新的專案。某天，主管又丟給你一份大型專案，說：「這是公司很重要的專案，過去的努力能不能有成果就看這次的表現，再加把勁，目標就在眼前了。」</p>
                            </div>
                            <ul>
                                <li class="question">	
                                    <h5>1.下屬服從上司的指令是天經地義的事。</h5>
                                    <ul class="option">
                                        <li class="answer">
                                            <input type='radio' value='11' class='q1' id='q11' name="q1" v-model='q1'>
                                            <label for='q11'>總是</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='8' class='q2' id='q12' name="q1" v-model='q1'>
                                            <label for='q12'>經常</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='5' class='q3' id='q13' name="q1" v-model='q1'>
                                            <label for='q13'>偶爾</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='2' class='q4' id='q14' name="q1" v-model='q1'>
                                            <label for='q14'>很少</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='0' class='q5' id='q15' name="q1" v-model='q1'>
                                            <label for='q15'>從不</label>
                                        </li>
                                    </ul>
                                </li>
                                <li class="question">	
                                    <h5>2.若不服從主管的安排，他會將我打入冷宮。</h5>
                                    <ul class="option">
                                        <li class="answer">
                                            <input type='radio' value='11' class='q1' id='q21' name="q2" v-model='q2'>
                                            <label for='q21'>總是</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='8' class='q2' id='q22' name="q2" v-model='q2'>
                                            <label for='q22'>經常</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='5' class='q3' id='q23' name="q2" v-model='q2'>
                                            <label for='q23'>偶爾</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='2' class='q4' id='q24' name="q2" v-model='q2'>
                                            <label for='q24'>很少</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='0' class='q5' id='q25' name="q2" v-model='q2'>
                                            <label for='q25'>從不</label>
                                        </li>
                                    </ul>
                                </li>
                                <li class="question">	
                                    <h5>3.主管算是我的伯樂，我不能讓他對我失望。</h5>
                                    <ul class="option">
                                        <li class="answer">
                                            <input type='radio' value='11' class='q1' id='q31' name="q3" v-model='q3'>
                                            <label for='q31'>總是</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='8' class='q2' id='q32' name="q3" v-model='q3'>
                                            <label for='q32'>經常</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='5' class='q3' id='q33' name="q3" v-model='q3'>
                                            <label for='q33'>偶爾</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='2' class='q4' id='q34' name="q3" v-model='q3'>
                                            <label for='q34'>很少</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='0' class='q5' id='q35' name="q3" v-model='q3'>
                                            <label for='q35'>從不</label>
                                        </li>
                                    </ul>
                                </li>
                                <li class="question">	
                                    <h5>4.主管會這樣做一定有他的理由，我應該要相信他。</h5>
                                    <ul class="option">
                                        <li class="answer">
                                            <input type='radio' value='11' class='q1' id='q41' name="q4" v-model='q4'>
                                            <label for='q41'>總是</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='8' class='q2' id='q42' name="q4" v-model='q4'>
                                            <label for='q42'>經常</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='5' class='q3' id='q43' name="q4" v-model='q4'>
                                            <label for='q43'>偶爾</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='2' class='q4' id='q44' name="q4" v-model='q4'>
                                            <label for='q44'>很少</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='0' class='q5' id='q45' name="q4" v-model='q4'>
                                            <label for='q45'>從不</label>
                                        </li>
                                    </ul>
                                </li>
                                <li class="question">	
                                    <h5>5.主管在想辦法提拔我，我不能辜負他對我的期待。</h5>
                                    <ul class="option">
                                        <li class="answer">
                                            <input type='radio' value='11' class='q1' id='q51' name="q5" v-model='q5'>
                                            <label for='q51'>總是</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='8' class='q2' id='q52' name="q5" v-model='q5'>
                                            <label for='q52'>經常</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='5' class='q3' id='q53' name="q5" v-model='q5'>
                                            <label for='q53'>偶爾</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='2' class='q4' id='q54' name="q5" v-model='q5'>
                                            <label for='q54'>很少</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='0' class='q5' id='q55' name="q5" v-model='q5'>
                                            <label for='q55'>從不</label>
                                        </li>
                                    </ul>
                                </li>
                                <li class="question">	
                                    <h5>6.我誤會主管了，這份大企劃我會盡全力努力完成。</h5>
                                    <ul class="option">
                                        <li class="answer">
                                            <input type='radio' value='11' class='q1' id='q61' name="q6" v-model='q6'>
                                            <label for='q61'>總是</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='8' class='q2' id='q62' name="q6" v-model='q6'>
                                            <label for='q62'>經常</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='5' class='q3' id='q63' name="q6" v-model='q6'>
                                            <label for='q63'>偶爾</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='2' class='q4' id='q64' name="q6" v-model='q6'>
                                            <label for='q64'>很少</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='0' class='q5' id='q65' name="q6" v-model='q6'>
                                            <label for='q65'>從不</label>
                                        </li>
                                    </ul>
                                </li>
                                <li class="question">	
                                    <h5>7.重要的專案交給了我，如果不盡力去做可能會帶給公司麻煩。</h5>
                                    <ul class="option">
                                        <li class="answer">
                                            <input type='radio' value='11' class='q1' id='q71' name="q7" v-model='q7'>
                                            <label for='q71'>總是</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='8' class='q2' id='q72' name="q7" v-model='q7'>
                                            <label for='q72'>經常</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='5' class='q3' id='q73' name="q7" v-model='q7'>
                                            <label for='q73'>偶爾</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='2' class='q4' id='q74' name="q7" v-model='q7'>
                                            <label for='q74'>很少</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='0' class='q5' id='q75' name="q7" v-model='q7'>
                                            <label for='q75'>從不</label>
                                        </li>
                                    </ul>
                                </li>
                                <li class="question">	
                                    <h5>8.若不繼續滿足主管的期待，之前的努力就白費了，升官和加薪更沒希望。</h5>
                                    <ul class="option">
                                        <li class="answer">
                                            <input type='radio' value='11' class='q1' id='q81' name="q8" v-model='q8'>
                                            <label for='q81'>總是</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='8' class='q2' id='q82' name="q8" v-model='q8'>
                                            <label for='q82'>經常</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='5' class='q3' id='q83' name="q8" v-model='q8'>
                                            <label for='q83'>偶爾</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='2' class='q4' id='q84' name="q8" v-model='q8'>
                                            <label for='q84'>很少</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='0' class='q5' id='q85' name="q8" v-model='q8'>
                                            <label for='q85'>從不</label>
                                        </li>
                                    </ul>
                                </li>
                                    <li class="question">	
                                    <h5>9.官官相護，如果我拒接主管交辦的工作，以後我會成為不受歡迎的棘手員工。</h5>
                                    <ul class="option">
                                        <li class="answer">
                                            <input type='radio' value='11' class='q1' id='q91' name="q9" v-model='q9'>
                                            <label for='q91'>總是</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='8' class='q2' id='q92' name="q9" v-model='q9'>
                                            <label for='q92'>經常</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='5' class='q3' id='q93' name="q9" v-model='q9'>
                                            <label for='q93'>偶爾</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='2' class='q4' id='q94' name="q9" v-model='q9'>
                                            <label for='q94'>很少</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='0' class='q5' id='q95' name="q9" v-model='q9'>
                                            <label for='q95'>從不</label>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                            <div>
                                <div class="btn" @click.prevent="coreCount()">看結果</div>
                            </div>
                        </div>
                        <div v-show="step === 2" id="form_part2">
                            <div class="container center">
                                <div class="col-lg-8">
                                    <div class="container">
                                        <div class="row">
                                            <div class="col-lg-6">
                                                <img id="highimg">
                                            </div>
                                            <div class="col-lg-6">
                                                <h5 id="dectext"></h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="container">
                                <h4>測測其他關係：</h4>
                                <div class="row">
                                    <div class="col-lg-4 col-md-4 col-sm-12">
                                        <div class="icon-h center">
                                            <img class="family" src="static/icon/family.png">
                                        </div>
                                        <router-link to="/detection/family" class="btn m10">親情</router-link>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12">
                                        <div class="icon-h center">
                                            <img class="friend" src="static/icon/friend.png">
                                        </div>
                                        <router-link to="/detection/friend" class="btn m10">友情</router-link>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12">
                                        <div class="icon-h center">
                                            <img class="love" src="static/icon/love.png">
                                        </div>
                                        <router-link to="/detection/love" class="btn m10">愛情</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios";
export default({
    name: 'detectionwork',
    data() {
        return {
            step:1,
        }
    },
    methods: {
        prev() {
            this.step--;
        },
        next() {
            console.log('dd');
            this.step++
            
        },
        coreCount(){
            this.step++
            var cores=0;
            var qestions=document.getElementsByClassName("question")
            for(var i=0;i<qestions.length;i++)
            {
                var count=0;
                var flag=1;
                var answer=document.getElementsByName("q"+(i+1));
                for(var j=0;j<answer.length;j++)
                {
                    if(answer[j].checked)
                    {
                        count+=answer[j].value*1;
                        console.log(count)
                    }
                }
                if(flag==1)
                    cores+=count;
                    console.log(cores);
                if(cores >= 76){
                    document.getElementById('dectext').innerHTML='糟糕，你被情緒勒索的程度很高喔！情緒勒索的戲碼一而再再而三地重複上演，你必須開始思考自己在關係中的定位以及如何讓自己更開心，並努力嘗試改善關係狀態喔～';
                    document.getElementById('highimg').src='static/高.png';
                }else if(cores >= 51 && cores <= 75){
                    document.getElementById('dectext').innerHTML='哎呀，你被情緒勒索的程度介於中間！你很容易受到各種方式的情緒勒索。建議你隨時注意、觀察自己的狀態，以避免深陷於勒索的情況喔～';
                    document.getElementById('highimg').src='static/中.png';
                }else if(cores >= 26 && cores <= 50){
                    document.getElementById('dectext').innerHTML='耶嘿，你被情緒勒索的程度很低喔！你可能經歷過幾段被勒索的關係，但似乎成功逃離了呢～';
                    document.getElementById('highimg').src='static/輕.png';
                }else if(cores < 25){
                    document.getElementById('dectext').innerHTML='恭喜你，你沒有被情緒勒索困擾喔！你不是容易被欺負的對象，你所處的關係中幾乎沒有情緒勒索的出現～';
                    document.getElementById('highimg').src='static/健康.png';
                }  
            }	
        }
    },
})



</script>

<style>

form{
	margin-top: 20px ;
	list-style: none;
	border-radius: 5px;
    background-color: #fff;
    padding: 20px;
}
.question{
    padding: 10px;
    text-align: left;
    background-color:rgba(229,222,165,0.1);
    border-radius: 5px;
    margin-bottom: 20px;
    margin-right: 40px;
}


.answer{
    display: inline-block;
    margin-top: 10px;
}

form h2{
    font-size: 30px;
}

.btn{
    margin: 10px 20px 10px 20px;
}








input[type=radio]{
    visibility:hidden;
}

label {
    background-color:rgba(229,222,165,0.25);
    position:relative;
    display: inline-block;
    border-radius: 5px;
    cursor: pointer;
    z-index: 1;
    padding: 10px 25px;
    margin-right: 10px;
    margin-bottom: 6px;
}

input[type=radio]:checked + label{
    background-color:#EEB868;
    color:#fff;
    padding: 10px 25px;
}

input[type=submit]{
    background-color:#EEB868;
    color:#fff;
    padding: 15px 25px;
    border:none;
    border-radius: 5px;
    margin-top:30px;
    font-weight: bold;
    font-size: 18px;
}

input[type=submit]:hover{
    font-size:20px;
}



</style>


// WEBPACK FOOTER //
// src/components/pages/DetectionWork.vue